import { Popover } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import Tooltip from "./Tooltip";

const ChaptersPopUpView = ({ row, cell, anchorEl, setAnchorEl }) => {

  const [chapterDetails, setChapterDetails] = useState([]);

  // const formatTime = (value) => {
  //   console.log("value:", parseInt(value));
  //   value = parseInt(value);
  //   if (!value && value !== 0) return "-";
  //   const days = Math.floor(value / (60 * 24));
  //   const hours = Math.floor((value % (60 * 24)) / 60);
  //   const minutes = value % 60;
  //   console.log(days, hours, minutes);

  //   const result = [];
  //   if (days > 0) result.push(`${days}d`);
  //   if (hours > 0) result.push(`${hours}h`);
  //   if (minutes > 0 && days < 1) result.push(`${minutes}m`);
  //   console.log("results:", result);

  //   return result.join(" ") || "0m";
  // };

const convertTimeSpent = (time, libType) => {
  if (!time || time <= 0) return "-";

  // Normalize to minutes
  const totalMinutes =
    libType === "Content"
      ? Math.floor(time / 60) // seconds → minutes
      : Math.floor(time);     // already minutes

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);

  return parts.join(" ") || "-";
};

  const getChapterDetails = () => {
    const chapters = row[`${cell.key}_chapters`];

    setChapterDetails(
      cell?.chapters?.map((detail) => ({
        name: detail.chaptername,
        timespent:
          convertTimeSpent(chapters.find((item) => item.id === detail.cid)?.timespent ?? "0m", cell.key),
        totalduration: convertTimeSpent(detail.duration), //content is already in minutes for headers
      }))
    );
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    getChapterDetails();
    console.log("ChapterDetails:", chapterDetails);
  }, [anchorEl]);

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: 60,
        }}
      >
        <div className="chapter-summary-main-container">
          <div className="chapter-summary-heading">Chapters:</div>
          {chapterDetails &&
            chapterDetails?.map((detail) => (
              <div className="chapter-summary-row">
                <Tooltip title={detail.name} placement="top-start">
                <div className="chapter-summary-name">{detail.name}</div>
                </Tooltip>
                <div className="chapter-summary-timespent">{`${detail.timespent}/${detail.totalduration}`}</div>
              </div>
            ))}
        </div>
      </Popover>
    </div>
  );
};

export default ChaptersPopUpView;
